import React from 'react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.vivara.healthcare';

const ShareIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
  </svg>
);

const LinkIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
  </svg>
);

const GlobeIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);

const ShareSheet = ({ reel, onClose, onShare }) => {
  const shareUrl = `${window.location.origin}/#/reels${reel?._id ? `?reelId=${reel._id}` : ''}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      onShare(reel?._id, 'share');
      onClose();
    } catch (e) { console.error(e); }
  };

  const shareNative = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Check out this reel',
          text: reel?.caption || 'Watch this reel on Vivara',
          url: shareUrl
        });
        onShare(reel?._id, 'share');
        onClose();
      } catch (e) { if (e.name !== 'AbortError') console.error(e); }
    } else {
      copyLink();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative bg-gray-900 rounded-t-2xl w-full max-w-lg p-6 pb-10"
        onClick={e => e.stopPropagation()}>
        <div className="w-10 h-1 bg-gray-600 rounded-full mx-auto mb-6" />
        <h3 className="text-lg font-semibold text-light text-center mb-5">Share this Reel</h3>
        <div className="grid grid-cols-3 gap-4">
          <button onClick={shareNative}
            className="flex flex-col items-center gap-2">
            <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center">
              <ShareIcon className="w-6 h-6 text-gold" />
            </div>
            <span className="text-xs text-gray-400">Share Link</span>
          </button>
          <button onClick={copyLink}
            className="flex flex-col items-center gap-2">
            <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center">
              <LinkIcon className="w-6 h-6 text-gold" />
            </div>
            <span className="text-xs text-gray-400">Copy Link</span>
          </button>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer"
            className="flex flex-col items-center gap-2">
            <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center">
              <GlobeIcon className="w-6 h-6 text-gold" />
            </div>
            <span className="text-xs text-gray-400">Get App</span>
          </a>
        </div>
        <p className="text-xs text-gray-500 text-center mt-4">
          Recipients without the app will be redirected to the Play Store
        </p>
      </div>
    </div>
  );
};

export default ShareSheet;
